import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import BufferOptionsItem from 'buffers/BufferOptionsItem';
import HiddenAnnotationsWarningBadge from 'molbio/maps/options/HiddenAnnotationsWarningBadge';
import MapSelector from 'molbio/maps/options/MapSelector';
import {SimplifiedMiniMapSequenceOptionsProps} from 'molbio/maps/options/MiniMapSequenceOptionsView';
import {ZoomSlider} from 'molbio/maps/options/Sliders';
import {shouldShowHiddenAnnotationsWarning} from 'molbio/maps/options/utils';
import DisplayOptions from 'settings/visibility-options/DisplayOptions';

export default function SimplifiedMiniMapOptions({
  mapType,
  onSelectMapType,
  isCircular,
  visibilityOptions,
  featureCounts,
  zoomSliderProps,
  shownAnnotationsCount,
  visibleAnnotationsCount,
}: SimplifiedMiniMapSequenceOptionsProps): JSX.Element {
  return (
    <div className="buffer-options-container">
      <BufferOptionsItem>
        <MapSelector mapType={mapType} onSelectMapType={onSelectMapType} isCircular={isCircular} />
      </BufferOptionsItem>
      <BufferOptionsItem>
        <ZoomSlider {...zoomSliderProps} />
      </BufferOptionsItem>
      {shouldShowHiddenAnnotationsWarning({
        shownAnnotationsCount,
        visibleAnnotationsCount,
      }) && <HiddenAnnotationsWarningBadge />}
      <BufferOptionsItem className={css(styles.expander)} />
      <BufferOptionsItem className="u-vertical-center-items">
        <DisplayOptions dropLeft={true} options={visibilityOptions} featureCounts={featureCounts} />
      </BufferOptionsItem>
    </div>
  );
}

const styles = StyleSheet.create({
  expander: {
    // Normally the banner has a flex value so it expands and pushes the DisplayOptions and SearchButton
    // all the way to the right.
    flex: 1,
  },
});
